import {TableRow as MUITableRow} from '@mui/material'
import React from 'react'

interface TableRowProps extends React.ComponentProps<typeof MUITableRow> {}

export const TableRow: React.FC<TableRowProps> = (props) => {
  return <MUITableRow {...props} />
}
